import { render, staticRenderFns } from "./RevenueKolSummary.vue?vue&type=template&id=6a4f9ba8&scoped=true"
import script from "./RevenueKolSummary.vue?vue&type=script&lang=js"
export * from "./RevenueKolSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f9ba8",
  null
  
)

export default component.exports